import { IIssue } from 'common/module_interface/RiskManagement/issues/Issues.interface';
import { IIssueCve } from '../../../../Issues.interface';
import { IProtectedAssetViewModel } from 'common/components/ProtectedAssets/ProtectedAssetsTable.interface';
import { fetchIssueVulnerabilities } from '../../../../Issues.utils';

export const getIssueCves = async (issue: IIssue, asset: IProtectedAssetViewModel): Promise<IIssueCve[]> => {
    const cves: IIssueCve[] = await fetchIssueVulnerabilities(issue, asset);
    return cves;
};
